import { render, staticRenderFns } from "./UnsereHotline.vue?vue&type=template&id=7a4621d1&scoped=true&"
import script from "./UnsereHotline.vue?vue&type=script&lang=js&"
export * from "./UnsereHotline.vue?vue&type=script&lang=js&"
import style0 from "./UnsereHotline.vue?vue&type=style&index=0&id=7a4621d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4621d1",
  null
  
)

export default component.exports